"use client";

import type { Locale } from "@/config/i18n";
import { EXCURSION_UI } from "./excursionUi";
import { tr } from "@/config/localeText";

type Step = { title: string; description?: string };

type Props = {
  title: string;
  steps: Step[];
  locale?: Locale;
};

const ItinerarySection = ({
  title,
  steps,
  locale = "fr",
}: Props): JSX.Element => {
  const ui = tr(EXCURSION_UI, locale);
  return (
    <section className="relative bg-white py-16 text-black">
      <div className="relative mx-auto max-w-[90rem] px-6 md:px-8">
        <h2 className="mb-2 font-space-age text-lg tracking-[0.2em]">
          {title}
        </h2>
        <p className="mb-8 max-w-3xl text-sm text-black/70">
          {ui.itineraryIntro}
        </p>
        <ol className="grid gap-5 md:grid-cols-2">
          {steps.map((s, idx) => (
            <li
              key={idx}
              className="relative overflow-hidden rounded-2xl border border-black/10 bg-black/[0.02] p-6"
            >
              <div className="absolute right-5 top-5 inline-flex h-8 w-8 items-center justify-center rounded-full bg-black/10 text-xs">
                {idx + 1}
              </div>
              <div className="pe-10">
                <div className="text-sm font-semibold text-black">
                  {s.title}
                </div>
                {s.description && (
                  <p className="mt-1 text-sm text-black/75">{s.description}</p>
                )}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default ItinerarySection;
